export const ArrowDown: React.FC<any> = ({
  className,
  width = 11,
  height = 7,
}) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg
        width="${width}"
        height="${height}"
        viewBox="0 0 11 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <path
            d="M1 1L5.5 5.5L10 1"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        </svg>
    `,
      }}
    />
  );
};
